import React, { useState } from 'react';
import { TermsModal } from './TermsModal';
import { PrivacyModal } from './PrivacyModal';
export function Footer() {
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  return <footer className="bg-[#3D2B1F] text-[#FAF3E8] py-12 px-4 text-center" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <div className="font-heading font-bold text-2xl mb-6" data-id="element-3">
          Drenaje<span className="text-[#C8956C]" data-id="element-4">Brasileño</span>
        </div>

        <p className="text-sm text-[#FAF3E8]/70 mb-8 max-w-2xl mx-auto" data-id="element-5">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-[#C8956C]" data-id="element-6">
          <button onClick={() => setIsTermsOpen(true)} className="hover:text-white transition-colors" data-id="element-7">
            Términos y Condiciones
          </button>
          <button onClick={() => setIsPrivacyOpen(true)} className="hover:text-white transition-colors" data-id="element-8">
            Políticas de Privacidad
          </button>
        </div>

        <p className="mt-8 text-xs text-[#FAF3E8]/50" data-id="element-9">
          &copy; {new Date().getFullYear()} Drenaje Brasileño. Todos los
          derechos reservados.
        </p>
      </div>

      <TermsModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} data-id="element-10" />
      <PrivacyModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} data-id="element-11" />
    </footer>;
}